import React, { Component } from 'react';
import './test-result-details.scss';
import { Constants, ImageConstants, StatusText } from '../../../../constants/constants';
import { getImageSource } from '../../../../utility/image-source'
import CwContentViewer from '../../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../../common/canvas/canvas'
import GeometryTranspiler from '../../../common/geometry/geometry-parser'
import ReactTooltip from 'react-tooltip';
import TestApi from '../../../../apis/test'
import Dropdown from '../../../common/dropdown-v2/dropdown';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faEllipsisV, faExpandArrowsAlt, faArrowLeft, faArrowRight, faDotCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { Modal, ModalBody } from 'reactstrap';
// import { PDFDownloadLink } from '@react-pdf/renderer';
import AnswerSheet from '../answer-sheet-pdf-report/answer-sheet-pdf-report';
import jsPDF from 'jspdf';
import * as html2canvas from 'html2canvas';

import SessionCache from '../../../routes/session-cache';



class TestResultDetails extends Component {

    constructor(props) {
        super(props)

        this.state.selectedAction = this.props.selectedAction;
        console.log(this.props)

    }
    state = {
        selectedAction: 'ResultDetails',
        questions: [],
        activeTabIndex: [],
        showImage: [],
        userInfo: {}
    }
    dropdownData = [
        {
            title: 'All',
            value: 'ALL'
        },
        {
            title: 'Correct',
            value: 'CORRECT'
        },
        {
            title: 'In-Correct',
            value: 'IN_CORRECT'
        },
        {
            title: 'Not Attempted',
            value: 'NOT_ATTEMPTED'
        }
    ]

    componentDidMount() {
        this.getTestDetailReport()
        let userInfo = SessionCache.getUser()
        this.setState({ userInfo })
        console.log(this.props.selectedItem)
    }


    getTestDetailReport(payload = {}) {

        this.setState({ isLoading: true })

        if (payload.page) payload.page = 1
        if (payload.page) payload.limit = this.limit

        payload.testId = this.props.selectedItem._id
        payload.userId = this.props.student?.userId

        TestApi.getTestStudentDetailReport(payload)
            .then(response => {
                console.log(response)
                this.setState({
                    questions: response.questions || [],
                    backupQuestions: response.questions || [],
                    activity: response
                })
            }).catch(err => {
            })
    }

    getChapterNames(chapters) {
        let arr = []
        for (let i = 0; i < chapters.length; i++) {
            arr.push(chapters[i].title)
        }
        return arr.join(", ")
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{this.getChapterNames(this.props.selectedItem?.chapters)} {`>`} </span>
                <span className='pl-2'>{this.getDate(this.props.selectedItem?.createdDateTimestamp)}</span>
            </div>
        )
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }



    renderResultColor = (result) => {

        switch (result) {
            case 'CORRECT':
                return '#4CCAB7'

            case 'IN_CORRECT':
                return '#FF7171'

            case 'NOT_ATTEMPTED':
                return '#FFC571'

            default:
                return '#FFC571'
        }

    }

    onClickBack = () => {
        this.props.delegate && this.props.delegate.hideTestResultDetailsReport && this.props.delegate.hideTestResultDetailsReport()
    }

    // onSaveEditMark = (item, index) => {

    //     if (!this.state.edittedMark) {
    //         this.setState({ errorMessage: "Please Enter Mark" })
    //         return
    //     }

    //     let list = this.state.questions

    //     list[index].finalMarks = this.state.edittedMark

    //     this.setState({ questions: list }, () => {
    //         this.setState({ edittedMark: "", editMark: false })
    //     })
    // }

    changeMark = (index) => {
        this.setState({ editMark: true, selectedIndex: index })
    }

    closeEditMark = () => {
        this.setState({ editMark: false })
    }

    onChangeHandler = (value, item, index) => {
        this.setState({ edittedMark: value })
    }

    changeAction = () => {
        if (this.state.selectedAction == 'ResultDetails') {
            this.setState({ selectedAction: 'AnswerSheet', showMenuOptions: false })
            return
        }
        if (this.state.selectedAction == 'AnswerSheet') {
            this.setState({ selectedAction: 'ResultDetails', showMenuOptions: false })
            return
        }
    }

    getOptionStyle = (userSelections, id, isCorrect) => {
        if (!userSelections) return ""
        if (userSelections.answer) {
            const answer = userSelections.answer
            console.log(answer)
            const idx = answer.findIndex(a => a.id === id)
            if (idx >= 0) {
                return isCorrect ? "correct-answer-border" : "incorrect-answer-border"
            } else {
                return isCorrect ? "correct-answer-border" : ""
            }
        }
    }

    getUserSelection = (userSelections, id, isCorrect) => {
        if (!userSelections) return ""
        if (userSelections.answer) {
            const answer = userSelections.answer
            console.log(answer)
            const idx = answer.findIndex(a => a.id === id)
            if (idx >= 0) {
                return isCorrect ?
                    <img className='answer-result-icon' src={getImageSource(ImageConstants.CORRECT_ANSWER)} /> :
                    <img className='answer-result-icon' src={getImageSource(ImageConstants.WRONG_ANSWER)} />
            } else {
                return isCorrect ?
                    <img className='answer-result-icon' src={getImageSource(ImageConstants.CORRECT_ANSWER)} />
                    : ""
            }
        }
    }

    onClickTab = (id, val) => {
        const { activeTabIndex } = this.state
        activeTabIndex[id] = val
        this.setState({
            activeTabIndex
        })
    }

    renderContentType = (contentType, content) => {
        const { activeTabIndex } = this.state
        switch (contentType) {

            case 1:
                return (
                    <div>
                        <div >
                            {!content.content.isMultiStep && content.content.options.map((item, index) =>
                                <div className={`mb-4 ml-2 row sequence-option 
                                        ${this.getOptionStyle(content.answer, item.id, item.isCorrect)}`} >
                                    <div className='col-1 '>
                                        {this.getUserSelection(content.answer, item.id, item.isCorrect)}
                                    </div>
                                    <div className='col 6'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>
                                </div>
                            )}
                            <>
                                <div className='tab-container'>
                                    <div className='tab-inner-container'>
                                        {content.content.isMultiStep && content.content.steps.map((step, index) => (
                                            <div
                                                key={'tab0'}
                                                className={`tab mr-3 ${(!activeTabIndex[content.id] && index === 0) || (activeTabIndex[content.id] == index) ? 'tab-active' : ''}`}
                                                onClick={() => this.onClickTab(content.id, index)}
                                            >
                                                <div className='tab-center'>
                                                    <span>Branch Qs {index + 1}</span>
                                                </div>
                                                {(!activeTabIndex[content.id] && index === 0) || (activeTabIndex[content.id] == index) ? <div className='active-cirlce'></div> : ''}
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </>
                            {content.content.isMultiStep && content.content.steps.map((step, index) => (
                                <>
                                    {((!activeTabIndex[content.id] && index === 0) ||
                                        (activeTabIndex[content.id] == index)) && (
                                            <>
                                                <div className='qn-title'><CwContentViewer content={step.content.title} /></div>
                                                {step.content.options.map((item, index) => (
                                                    <div className='mb-2 ml-1 row sequence-option'>
                                                        <div className='col-2 '>
                                                            {this.getUserSelection(content.answer, item.id, item.isCorrect)}
                                                        </div>
                                                        <div className='col 6'>
                                                            {item.contentTypeName == 'TEXT' ? (
                                                                // <span className='' dangerouslySetInnerHTML={{ __html: item.content }} />
                                                                <CwContentViewer content={item.content} />
                                                            ) : (
                                                                <div className=''>
                                                                    <img
                                                                        className='image-option-container'
                                                                        src={item.content}
                                                                        alt=''
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </>
                                        )}
                                </>
                            ))}
                        </div>
                    </div >

                )

            case 2:
                return (
                    <div>
                        <div >
                            {content.content.options.map((item, index) =>
                                <div className='mb-4 ml-2 row sequence-option'>
                                    <div className='col-1'>
                                        <div className='check-box'></div>
                                    </div>
                                    <div className='col 6'>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 4:
                return (

                    <div>
                        <div className='row'>
                            {content.content.options.map((item, index) =>
                                <div className={`col-2 matching-option  `} style={{ borderColor: 'red' }}>
                                    {item.question.contentTypeName == 'TEXT' ?
                                        <div className='match-option'><CwContentViewer content={item.question.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.question.content} alt="" />
                                        </div>
                                    }
                                    <div className='text-center'><img className='match-arrow my-2' onClick={this.props.onClose} src={getImageSource(ImageConstants.MATCHING_ARROW)} /></div>
                                    {item.answer.contentTypeName == 'TEXT' ?
                                        <div className='match-option'><CwContentViewer content={item.answer.content} /></div>
                                        :
                                        <div className='match-option'>
                                            <img className='image-option-container' src={item.answer.content} alt="" />
                                        </div>
                                    }
                                </div>
                            )}

                        </div>
                    </div>

                )

            case 5:

                return (
                    <div>
                        <div >
                            {content.content.options.map((item, index) =>
                                <div className='mb-4 ml-2 row sequence-option'>
                                    <div className='col-2'>
                                        <img className='match-arrow drag-container' onClick={this.props.onClose} src={getImageSource(ImageConstants.DRAG_ICON)} />
                                    </div>
                                    <div className='sequence-border'></div>
                                    <div className='col 6 '>{item.contentTypeName == 'TEXT' ?
                                        <CwContentViewer content={item.content} />
                                        :
                                        <div className=''>
                                            <img className='image-option-container' src={item.content} alt="" />
                                        </div>
                                    }
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>

                )

            case 6:

                let items = []

                for (let i = 0; i < content.content.options.length; i++) {
                    items = items.concat(content.content.options[i].items)
                }
                return (
                    <div>
                        <div className='row option-wrapper '>
                            {items.map((item, index) =>
                                <div className='ml-2 mt-4'> {item.contentTypeName == 'TEXT' ?
                                    <div className='group-items'><CwContentViewer content={item.content} /></div>
                                    :
                                    <div className='group-items'>
                                        <img className='image-option-container' src={item.content} alt="" />
                                    </div>
                                }</div>
                            )}
                        </div>
                        <div className='row mt-4'>
                            {content.content.options.map((item, index) =>
                                <div className='ml-2 group-option'>
                                    <div className='group-header px-3'>
                                        <div className='text-center mt-2'><CwContentViewer content={item.title} /></div>
                                    </div>

                                </div>
                            )}

                        </div>
                    </div>
                )

            case 10:
                if (content && content.content && content.content.canvas && content.content.canvas.render && content.content.canvas.render.script && content.content.canvas.render.script) {
                    let payload = GeometryTranspiler.transpile(content.content.canvas.render.script, 37.7952755906, 5) //centimeter ratio and x offset
                    if (payload) {
                        let { maxWidth, maxHeight } = this.getCanvasSize(payload)
                        this.canvasMaxWidth = maxWidth + 100
                        this.canvasMaxHeight = maxHeight + 100
                    }

                    return (
                        <CanvasPreview id={Math.random()} coordinates={payload || []} maxWidth={this.canvasMaxWidth} maxHeight={this.canvasMaxHeight} />
                    )
                }

            default:
                return ("")
        }

    }

    onSelectDropDown = (option) => {
        let questions = []
        let allQuestions = this.state.backupQuestions
        if (option?.value && option?.value !== "ALL") {
            questions = allQuestions.filter(item => item.status === option?.value)
        } else {
            questions = allQuestions
        }
        this.setState({ questions })
    }

    onSaveEditMark = (index) => {
        const re = /^[0-9\b]+$/;
        if (!this.state.finalMark || !re.test(this.state.finalMark)) {
            this.setState({
                errorMessage: "Enter valid mark"
            })
            return
        }
        let questions = this.state.questions || []
        let question = questions[index]
        if (question.marks < this.state.finalMark) {
            this.setState({
                errorMessage: "Final Mark cannot exceed mark"
            })
            return
        }
        question.finalMark = this.state.finalMark
        questions[index] = question



        let payload = {
            _id: this.state.activity?.activityId,
            questionId: question.questionId,
            finalMark: +this.state.finalMark
        }
        this.setState({ questions, showFinalIndex: "", finalMark: "" })
        console.log(payload)
        TestApi.updateUserAssessmentActivity(payload).then(response => {
        }).catch(err => {
        })
    }

    onChangeFinalHandler = (value) => {
        this.setState({ finalMark: value })
    }

    onEditFinalMark = (index) => {
        this.setState({ showFinalIndex: index })
    }
    onCloseFinalMark = () => {
        this.setState({ showFinalIndex: "" })
    }

    changeFinalMark = (mark, index) => {
        return (
            <div className="cw-card d-inline-block final-mark">
                <div className="close-icon-wrapper">
                    <img className="mark-close-icon cursor-pointer" onClick={this.onCloseFinalMark} src={getImageSource(ImageConstants.CROSS)} />
                </div>
                <div className='mt-2'>
                    <input className={`cw-input`} placeholder='Enter Marks'
                        value={this.state.finalMark}
                        onChange={(e) => this.onChangeFinalHandler(e.target.value, index)} />
                </div>

                <div className='text-center mt-2'>
                    {this.state.errorMessage && <div className='err-text'>{this.state.errorMessage}</div>}
                    <button className="cw-button-primary text-center" onClick={() => this.onSaveEditMark(index)}>
                        Save
                    </button>
                </div>
            </div>
        )
    }

    getQuestionStatus = status => {
        if (StatusText[status] === "Correct") {
            return <img className='status-img' src={getImageSource(ImageConstants.CORRECT)} />
        } else if (StatusText[status] === "Incorrect") {
            return <img className='status-img' src={getImageSource(ImageConstants.WRONG)} />
        } else {
            return "Not Attempted"
        }
    }

    showImageFullScreen = (images, index, iIndex) => {
        const { showImage } = this.state
        showImage[index] = iIndex
        this.setState({
            currentIndex: index,
            selectedImages: images,
            showImageFullScreen: true,
            showImage
        })
    }

    hideImageFullScreen = _ => {
        this.setState({
            currentIndex: 0,
            selectedImages: [],
            showImageFullScreen: false
        })
    }

    renderFullScreenImage() {
        const {
            selectedImages,
            currentIndex,
            showImage
        } = this.state
        const index = currentIndex;
        return (
            <Modal className="cw-custom-modal image-full-screen" isOpen={true} toggle={this.hideImageFullScreen} size={"xl"}>
                <ModalBody >
                    <div className="row px-2">
                        <div className="col text-right">
                            <img className="close-icon cursor-pointer" onClick={this.hideImageFullScreen} src={getImageSource(ImageConstants.CROSS)} />
                        </div>
                    </div>
                    <div className="px-5">
                        <div className='answer-image-container' >
                            {selectedImages?.length > 0 && selectedImages.map((image, imageIndex) => (
                                <>
                                    {((showImage[index] === imageIndex) || (!showImage[index] && imageIndex === 0)) &&
                                        <div className='answer-image text-center' key={imageIndex}>
                                            <img className='answer-image' src={image.url} />
                                        </div>
                                    }

                                </>
                            ))}
                            {selectedImages?.length > 0 &&
                                <div className='slider-pagination-buttons'>
                                    <div className='prev cursor-pointer' onClick={_ => {
                                        this.goToPrevImage(index)
                                    }}>
                                        <FontAwesomeIcon color='#FFFFFF' icon={faArrowLeft} />
                                    </div>
                                    {selectedImages.map((image, imageIndex) => (
                                        <div className='slider-page cursor-pointer' key={imageIndex} onClick={_ => {
                                            this.changeImageIndex(index, imageIndex)
                                        }}>
                                            <div className={`dot-circle ${((showImage[index] === imageIndex) || (!showImage[index] && imageIndex === 0)) ? "active" : ""}`}>

                                            </div>
                                        </div>
                                    ))}
                                    <div className='next cursor-pointer' onClick={_ => {
                                        this.goToNextImage(index, selectedImages.length)
                                    }}><FontAwesomeIcon color='#FFFFFF' icon={faArrowRight} /></div>
                                </div>
                            }
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        )
    }

    toggleMenuOptions = _ => {
        this.setState({
            showMenuOptions: !this.state.showMenuOptions
        })
    }

    changeImageIndex = (qIndex, iIndex) => {
        const { showImage } = this.state
        showImage[qIndex] = iIndex
        this.setState({
            showImage
        })
    }

    goToPrevImage = (qIndex) => {
        const { showImage } = this.state
        if (!showImage[qIndex] || showImage[qIndex] === 0) return
        showImage[qIndex] = showImage[qIndex] - 1
        this.setState({
            showImage
        })
    }

    goToNextImage = (qIndex, length) => {
        const { showImage } = this.state
        if (showImage[qIndex] === length - 1) return
        showImage[qIndex] = !showImage[qIndex] ? 1 : showImage[qIndex] + 1
        this.setState({
            showImage
        })
    }

    downloadPDF = () => {
        if (this.state.selectedAction != 'ResultDetails') {

            this.setState({ print: true })

            let elements = document.getElementById('print_answers');
            let elements1 = document.getElementById('hide_headers');
            let elements2 = document.getElementById('showText');
            let elements3 = document.getElementById('hide_back_icon');



            // html2canvas( elements, {logging : true, letterRendering : 1, useCORS : true}).then( canvas => {
            //     let imgWidth = 208;
            //     let imgHeight = canvas.height * imgWidth / canvas.width ;
            //     let imgData = canvas.toDataURL('img/png');
            //     let pdf = new jsPDF('p', 'mm', 'a4');
            //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight )
            //     pdf.save('answersheet.pdf');
            // })

            // printJS('elements' , 'html')
            this.printElement(elements, elements1, elements2, elements3)
            //this.printDiv('sara')

            // var divContents = document.getElementById("sara").innerHTML;
            // var printWindow = window.open('', '', 'height=1200,width=1200');
            // printWindow.document.write('<html><head><title>DIV Contents</title>');
            // printWindow.document.write('</head><body >');
            // printWindow.document.write(divContents);
            // printWindow.document.write('</body></html>');
            // printWindow.document.close();
            // printWindow.print();

        }

    }

    // printDiv(divName) {
    //     var printContents = document.getElementById(divName).innerHTML;
    //     var originalContents = document.body.innerHTML;

    //     document.body.innerHTML = printContents;

    //     window.print();

    //     document.body.innerHTML = originalContents;

    // }


    printElement(element, elements1, elements2, elements3) {
        if (!element) {
            throw new Error(`Invalid print target element`);
        }

        const printWrapper = "print-wrapper";
        const printElement = "print-element";
        const hideButton = 'hide-button';
        const showText = 'show_text';
        const hideBackButton = 'hide_back_button';

        const css = `
        body.${printWrapper} *:not(.${printElement}) {
          visibility:hidden;
        }
        body.${printWrapper} .${printElement} {
          width: 400mm;
          height: 1000mm;
          left:0;
          top:0;
          position:absolute;
        }
        body.${printWrapper} .${printElement} * {
          visibility:visible;
          margin: 0;
        }
        .${hideButton} {
            display:none
        }
        .${showText} {
            display : block
        }
        .${hideBackButton} {
            display:none
        }
        

        `;

        const head = document.getElementsByTagName("head")[0];
        const style = document.createElement("style");

        style.setAttribute("type", "text/css");
        style.setAttribute("media", "print");

        if (style.styleSheet) {
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(document.createTextNode(css));
        }

        head.appendChild(style);

        document.body.classList.add(printWrapper);
        element.classList.add(printElement);
        elements1.classList.add(hideButton)
        elements3.classList.add(hideBackButton);

        // document.write()
        // document.getElementById('print_answers').insertAdjacentHTML('beforebegin', "<div>test</div>")


        window.print();
        //setTimeout(function () { window.print(); }, 1000);

        // document.body.classList.remove(printWrapper);
        // element.classList.remove(printElement);
        // head.removeChild(style);
    }




    // handleGeneratePdf = async () => {

    //     const inputs = document.getElementsByClassName('qs-canvas');

    //     this.setState({ pdfButtonName: "Downloading...", pdfLoading: true })

    //     let height0 = inputs[0].offsetHeight
    //     let width0 = inputs[0].offsetWidth

    //     let canvas0 = await html2canvas(inputs[0])

    //     const imgData0 = canvas0.toDataURL('image/png');
    //     const pdf = new jsPDF({
    //       format: [height0 < 1000 ? 1000 : height0, width0],
    //       unit: "px"
    //     });

    //     pdf.addImage(imgData0, 'JPEG', 0, 0, width0, height0);


    //     for (let i = 1; i < inputs.length; i++) {
    //       let input = inputs[i]

    //       let height = input.offsetHeight
    //       let width = input.offsetWidth

    //       console.log(height, width)

    //       let canvas = await html2canvas(input)

    //       const imgData = canvas.toDataURL('image/png');
    //       pdf.addPage([height <1000 ?1000 :height, width])

    //       // pdf.addPage([height, width])

    //       pdf.addImage(imgData, 'JPEG', 0, 0, width, height);
    //     }

    //     let chapter = this.state.chaptersDropdown.find(item => item.value === this.state.selectedChapter)

    //     pdf.save(`${chapter.text}.pdf`);
    //     this.setState({ pdfButtonName: "Download PDF", pdfLoading: false })

    //   };

    calculatePercentage(scored = 0, total = 0) {

        if (scored == 0 || total == 0) return 0

        return Math.round((scored / total) * 100)
    }




    render() {
        const { showImage } = this.state;
        return (
            <div id='print_answers' className=' test-result-details-report-1' onScroll={ReactTooltip.hide()}>

                <div id='hide_headers'>
                    {this.state.selectedAction != 'ResultDetails' && <div className='download-container'>
                        <div className='download-option' onClick={this.downloadPDF} >
                            <img className='pdf-image' src={getImageSource(ImageConstants.PDF_ICON)}></img>
                        </div>
                    </div>}
                </div>



                <div id='hide_back_icon' className='mb-3 item1'>
                    <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                </div>



                {this.state.selectedAction !== 'ResultDetails' &&
                    <div>
                        <div className='row report-background'>
                            <div className='col school-name-margin'>
                                <div className='school-name' >{this.state.userInfo?.schoolInfo?.name}</div>
                                <div className='school-info'>
                                    <span>{this.state?.userInfo?.schoolInfo?.address?.branch || ''},{' '}
                                        {this.state?.userInfo?.schoolInfo?.address?.city || ''}</span>
                                </div>
                            </div>
                            <div className='col school-name'>
                                <p>Assessment Answer Sheet</p>
                            </div>
                            <div className='col-2 mt-2'>
                                <img className='countingwell-logo' src={getImageSource(ImageConstants.COUNTINGWELL_LOGO)} />
                            </div>
                        </div>

                        <div className='teacher-container mt-4'>
                            <div className='mr-4'>
                                <div className='title-key'>Chapter(s) : <span className='value-key'>{this.getChapterNames(this.props.selectedItem?.chapters)}</span> </div>
                            </div>
                            <div className='' >
                                <div className='title-key'>Teacher : <span className='value-key'> {this.state.userInfo?.name} </span> </div>
                            </div>
                        </div>

                        <div className='student-container'>
                            <div className='student-details-container'>
                                <div className='student-img'>
                                    <div className="">
                                        {
                                            this.props.student?.image ? <img className="student-image" alt="img" src={`${this.props.student.basePath}${this.props.student.image}`} />
                                                :
                                                <img className="student-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />
                                        }
                                    </div>
                                </div>
                                <div className='student-data'>
                                    <div className='student-name'>{this.props.student?.name}</div>
                                    <div>
                                        <span className='student-info' >Class : {this.props.selectedItem?.class} | {" "}</span>
                                        {this.props.selectedItem?.section ? <span> Section : {this.props.selectedItem?.section} | {" "}</span> : ''}
                                        {this.props.student?.rollNo ? <span>Roll No : {this.props.student?.rollNo}</span> : ' '}
                                    </div>
                                </div>
                            </div>
                            <div className='mark-details-container'>
                                <div className='time-details'>
                                    <div className='time-lable'>Total Time</div>
                                    <div className='time-lable'>(mins)</div>
                                    <div className='time'>{this.props.student?.time? this.props.student.time.replace("mins", "") : (this.state.activity?.timeTaken?.value || 0)}</div>
                                </div>
                                <div className='mark-details'>
                                    <div className='mark-detail'>
                                        <span className='circle correct-circle'></span>
                                        <span className='mark-text'>{this.props.student?.correct? this.props.student?.correct : (this.state.activity?.correct || 0)} Correct</span>
                                    </div>
                                    <div className='mark-detail'>
                                        <span className='circle incorrect-circle'></span>
                                        <span className='mark-text'>{this.props.student?.inCorrect ? this.props.student?.inCorrect :(this.state.activity?.inCorrect || 0)} In-Correct</span>
                                    </div>
                                    <div className='mark-detail'>
                                        <span className='circle not-attempt-circle'></span>
                                        <span className='mark-text'>{this.props.student?.notAttempted ? this.props.student?.notAttempted : (this.state.activity?.notAttempted || 0)} Not Attempted</span>
                                    </div>
                                </div>
                                <div className='consolidated-mark'>
                                    <div className='total-mark'>{this.props.student?.marks ? this.props.student?.marks : (this.state.activity?.markScored || 0) }</div>
                                    <div className='mark-divider'></div>
                                    <div className='total-mark'>{this.props.student?.totalMark ? this.props.student?.totalMark : (this.state.activity?.totalMark || 0)}</div>
                                </div>
                            </div>

                        </div>


                    </div>

                }


                {/* <span className='assessment-detail-screen-title'>{this.state.selectedAction == 'ResultDetails' ? 'Assessment Result Details' : ''}</span> */}
                {this.state.selectedAction === 'ResultDetails' && <>
                <div className='d-flex align-items-center justify-content-between header-report-card mb-3'>
                    <div className='d-flex align-items-center'>
                        <div>
                            <img className='circle-image' src={getImageSource(ImageConstants.EVALUATION_DETAIL_REPORT)} />
                        </div>
                        <div className='ml-2'>
                            <div className=''>
                                <span className='screen-title-1'>Question Analysis Report</span>
                                <span>{this.renderBreadcrumb()}</span>
                            </div>
                        </div>
                    </div>
                </div>
                    <div className='flex'>
                        <div className='student-test-info-card row ml-2'>
                            <div className="">
                                {
                                    this.props.student?.image ? <img className="student-image-1" alt="img" src={`${this.props.student.basePath}${this.props.student.image}`} />
                                        :
                                        <img className="student-image-1" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />
                                }
                            </div>
                            <div className='student-data  ml-2'>
                                <div className='student-name name-bold'>{this.props.student?.name}</div>
                                <div className='roll-no'>
                                    <span className='student-info' >Class : {this.props.selectedItem?.class} | {" "}</span>
                                    {this.props.selectedItem?.section ? <span> Section : {this.props.selectedItem?.section} | {" "}</span> : ''}
                                    {this.props.student?.rollNo ? <span>Roll No : {this.props.student?.rollNo}</span> : ' '}
                                </div>
                            </div>
                            <div className='ml-5'>
                                <div className='marks-card'>
                                    <div>
                                        <div className='student-name text-center'>{this.state.activity?.markScored || 0} / {this.state.activity?.totalMark || 0} </div>
                                        <div className='roll-no'>marks</div>
                                        <div className='student-name mt-1'>{this.calculatePercentage(this.state.activity?.markScored, this.state.activity?.totalMark)}%</div>
                                    </div>
                                </div>
                            </div>
                            <div className='ml-4'>
                                <div className='marks-card'>
                                    <div>
                                        <div className='student-name text-center'>{this.state.activity?.timeTaken?.value || 0}</div>
                                        <div className='roll-no'>Time({this.state.activity?.timeTaken?.unit || "sec"})</div>
                                    </div>
                                </div>
                            </div>
                            <div className='ml-4'>
                                <div className='answered-card'>
                                    <div>
                                        <div className='row'>
                                            <div className='dot green-dot'></div>
                                            <span className='roll-no'>{this.state.activity?.correct || 0} Correct</span>
                                        </div>
                                        <div className='row'>
                                            <div className='dot red-dot'></div>
                                            <div className='roll-no'>{this.state.activity?.inCorrect || 0} In-Correct</div>
                                        </div>
                                        <div className='row'>
                                            <div className='dot yellow-dot'></div>
                                            <div className='roll-no'>{this.state.activity?.notAttempted || 0} Not Attempted</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <div>
            <img className=' ml-4 icon-size cursor-pointer' src={getImageSource(this.state.selectedAction == 'ResultDetails' ? ImageConstants.ANSWER_ICON : ImageConstants.MENU_ICON)} onClick={() => this.changeAction()} />
        </div> */}
                            <div className='menu-options-container'>
                                {/* <div className='cursor-pointer ellipsis-icon'>
                                    <FontAwesomeIcon icon={faEllipsisV} color='#000000' onClick={this.toggleMenuOptions} />
                                </div> */}
                                {this.state.showMenuOptions && (
                                    <div className='menu-options'>
                                        <div className='text-right'>
                                            <img className='close-icn' onClick={this.toggleMenuOptions} src={getImageSource(ImageConstants.CROSS)} />
                                        </div>
                                        <div className='option cursor-pointer'>
                                            <span onClick={() => this.changeAction()}>{this.state.selectedAction == 'ResultDetails' && <>View Answer Sheet </>}</span>
                                            <span onClick={() => this.changeAction()}>{this.state.selectedAction == 'AnswerSheet' && <>Student Level Assessment Report</>}</span>
                                            {/* {this.state.selectedAction == 'ResultDetails' &&
                                                <PDFDownloadLink document={<AnswerSheet student={this.props.student} selectedItem={this.props.selectedItem} />} fileName="assessment_result_report.pdf">
                                                    {({ blob, url, loading, error }) => {
                                                        // console.log(error)
                                                        return (
                                                            loading ? <FontAwesomeIcon icon={faSpinner} color='#353535' /> : <FontAwesomeIcon icon={faDownload} color='#353535' />
                                                        )
                                                    }}
                                                </PDFDownloadLink>
                                            } */}
                                        </div>
                                    </div>
                                )
                                }
                            </div>
                        </div>
                        <div className="col-2 dropdown p-3" style={{background : 'rgb(233 232 232)', borderRadius:"10px"}}>
                            <div className="filter-input-label">
                                Filter
                            </div>
                            <div>
                                <Dropdown
                                    placeholder='ALL'
                                    options={this.dropdownData}
                                    onSelect={(option) => this.onSelectDropDown(option,)}
                                    text={"title"}
                                />
                            </div>
                        </div>
                    </div>
                </>}





                {
                    this.state.selectedAction === 'ResultDetails' && <div className='report-card-wrapper'>


                        <div id="table-scoll" className="table-responsive mt-3" style={{background : 'rgb(233 232 232)', borderRadius:"10px"}}>
                            <table className="table cw-table custom-report-table  align-items-center ">
                                <thead>
                                    <tr>
                                        <th className='th-left-radius text-center row-max-width'>Question</th>
                                        <th className='text-center'>Question Marks</th>
                                        <th className='text-center'>Result</th>
                                        <th className='text-center'>Workings</th>
                                        <th className='text-center'>Provisional</th>
                                        <th className='th-right-radius text-center'>Final</th>
                                    </tr>
                                </thead>
                                <tbody className="bg-white">
                                    {
                                        this.state.questions?.length ? this.state.questions?.map((item, index) => (

                                            <tr key={item._id} className="mt-4 ">
                                                <td>
                                                    <div className='row ml-3'>
                                                        <div className='mt-1'>{index + 1}</div>
                                                        <div className="qn-title-card ml-2">{item.content.title ? <CwContentViewer content={item.content.title} /> : ""}</div>
                                                    </div>
                                                </td>
                                                <td className='text-center'>{item?.questionTotalMark}</td>
                                                <td className='text-center' style={{ color: this.renderResultColor(item.status) }}><b>{this.getQuestionStatus(item?.status)}</b></td>
                                                <td className='text-center'>
                                                    <div className='solution-images'>
                                                        {/* {this.state.questions?.length > 0 && this.state.questions.map(q => {
                                                            return ( */}
                                                        <>
                                                            {item.attachments?.length > 0 && item.attachments.map((a, iIndex) => {
                                                                return (
                                                                    <div key={iIndex} className='solution-image cursor-pointer' onClick={_ => this.showImageFullScreen(item.attachments, index, iIndex)}>
                                                                        {a.type === "IMAGE" && <img src={a.url} />}
                                                                        <span className='full-screen'>
                                                                            <FontAwesomeIcon icon={faExpandArrowsAlt} color="#ffffff" />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            })}
                                                        </>

                                                    </div>
                                                </td>
                                                <td className='text-center'>{item?.provisional}</td>
                                                <td className='text-center'>
                                                    <div>{item?.finalMark ? item?.finalMark : item?.provisional}</div>
                                                    <div className='final-mark-edit mark-td'>
                                                        <span
                                                            className='edit-text cursor-pointer'
                                                            onClick={_ => this.onEditFinalMark(index)}>
                                                            Change
                                                        </span>
                                                        {this.state.showFinalIndex === index ?
                                                            this.changeFinalMark(item?.finalMark, index)
                                                            : ""}
                                                    </div>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                                    }
                                </tbody>
                            </table>
                        </div >
                    </div>

                }
                {
                    this.state.selectedAction === 'AnswerSheet' &&
                    <div className=' answer-sheet'>
                        <div className='cw-plain-card cw-card-position cw-answer-sheet-card-wrapper mt-4'>
                            {this.state.questions && this.state.questions.length && this.state.questions.map((item, index) =>
                                <div className="">
                                    <div className='row mx-1 mb-3 question-container'>
                                        <div className='sub-title'>Question {index + 1}</div>
                                        <div className='row mr-4'>
                                            {/* <div className='sub-title mr-2'>Time: {item.time}</div> */}
                                            <div className='mr-2'>
                                                {item.status === "CORRECT" && <img className='answer-result-icon' src={getImageSource(ImageConstants.CORRECT_ANSWER)} />}
                                                {item.status === "IN_CORRECT" && <img className='answer-result-icon' src={getImageSource(ImageConstants.WRONG_ANSWER)} />}
                                            </div>
                                            {/* <div className='sub-title'>
                                                Marks: {item?.finalMark ? item?.finalMark : item?.finalMark}
                                            </div> */}
                                            <div className='consolidated-question-mark ml-4'>
                                                <div className='total-mark'>{item?.marks ? item?.marks : item?.marks}</div>
                                                <div className='mark-divider'></div>
                                                <div className='total-mark'>{item?.questionTotalMark}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-6'>
                                            <CwContentViewer content={item.content.title} />
                                            <div className='mt-3'>{this.renderContentType(item.content.type, item)}</div>
                                        </div>


                                        <div className='col-6 answer-image-container' >
                                            {item.attachments?.length > 0 && item.attachments.map((image, imageIndex) => (
                                                <>
                                                    {((showImage[index] === imageIndex) || (!showImage[index] && imageIndex === 0)) &&
                                                        <div className='answer-image text-center' key={imageIndex} onClick={_ => this.showImageFullScreen(item.attachments, index, imageIndex)}>
                                                            <img className='answer-image' src={image.url} />
                                                        </div>
                                                    }
                                                    {/* <span className='full-screen' onClick={_ => this.showImageFullScreen(item.attachments, index, imageIndex)}>
                                                        <FontAwesomeIcon icon={faExpandArrowsAlt} color="#ffffff" />
                                                    </span> */}
                                                </>
                                            ))}

                                            {/* {item.attachments?.length > 0 &&
                                                <div id='slider-button-hide' className='slider-pagination-buttons'>
                                                    <div className='prev cursor-pointer' onClick={_ => {
                                                        this.goToPrevImage(index)
                                                    }}>
                                                        <FontAwesomeIcon color='#FFFFFF' icon={faArrowLeft} />
                                                    </div>
                                                    {item.attachments.map((image, imageIndex) => (
                                                        <div className='slider-page cursor-pointer' key={imageIndex} onClick={_ => {
                                                            this.changeImageIndex(index, imageIndex)
                                                        }}>
                                                            <div className={`dot-circle ${((showImage[index] === imageIndex) || (!showImage[index] && imageIndex === 0)) ? "active" : ""}`}>

                                                            </div>
                                                        </div>
                                                    ))}
                                                    <div className='next cursor-pointer' onClick={_ => {
                                                        this.goToNextImage(index, item.attachments.length)
                                                    }}><FontAwesomeIcon color='#FFFFFF' icon={faArrowRight} /></div>
                                                </div>
                                            } */}
                                        </div>
                                    </div>
                                    {index != this.state.questions.length - 1 && <div className='text-center '><img className="separator" src={getImageSource(ImageConstants.SEPARATOR)} /></div>}

                                </div>
                            )}
                        </div>

                    </div>

                }
                {this.state.showImageFullScreen && this.renderFullScreenImage()}
                <ReactTooltip ref={el => this.tooltip = el} multiline={true} place='bottom' type='dark' effect='solid' event="mouseover mouseenter" eventOff="mouseleave mouseout scroll mousewheel blur" />

            </div >);
    }
}

export default TestResultDetails;